import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon, XIcon } from '../lib/icons';
const COMPARISON_DATA = [{
  situation: 'Tu cliente pregunta cuántas sesiones necesita',
  sinKit: 'Improvisás la respuesta',
  conKit: 'Protocolo de evaluación listo. Paso a paso.'
}, {
  situation: 'Querés armar tu consultorio online',
  sinKit: 'No sabés por dónde empezar',
  conKit: 'Setup completo listo para implementar hoy'
}, {
  situation: 'Te piden precio por una sesión',
  sinKit: 'Bajás la voz — no sabés qué decir',
  conKit: 'Script de presentación y precios. Ya está.'
}, {
  situation: 'Necesitás documentar tus sesiones',
  sinKit: 'Buscás en internet lo que no encontrás',
  conKit: 'Formularios y fichas listas para imprimir'
}, {
  situation: 'Querés tener tu propio consultorio',
  sinKit: 'Se siente un sueño lejano',
  conKit: 'Sistema operativo. Un paso a la vez.'
}];
export function ComparisonSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" data-id="element-64">
      <div className="container mx-auto max-w-4xl" data-id="element-65">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-66">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-8 md:mb-12 text-center text-white tracking-wide" data-id="element-67">
            🧬 ¿QUÉ AGREGA EL KIT PROFESIONAL?
          </h2>

          <div className="overflow-x-auto pb-4" data-id="element-68">
            <table className="w-full min-w-[600px] border-collapse" data-id="element-69">
              <thead data-id="element-70">
                <tr data-id="element-71">
                  <th className="text-left p-4 border-b border-white/10 text-gray-400 font-medium w-1/3" data-id="element-72">
                    Situación
                  </th>
                  <th className="text-center p-4 border-b border-white/10 text-gray-400 font-medium w-1/3 bg-white/5 rounded-tl-lg" data-id="element-73">
                    Sin Kit
                  </th>
                  <th className="text-center p-4 border-b border-[#eab308]/30 text-[#eab308] font-bold w-1/3 bg-[#eab308]/10 rounded-tr-lg" data-id="element-74">
                    Con Kit
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-75">
                {COMPARISON_DATA.map((row, i) => <tr key={i} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors" data-id="element-76">
                    <td className="p-4 text-gray-300 text-sm md:text-base font-medium" data-id="element-77">
                      {row.situation}
                    </td>
                    <td className="p-4 text-center bg-white/5" data-id="element-78">
                      <div className="flex flex-col items-center gap-2" data-id="element-79">
                        <XIcon className="w-5 h-5 text-red-500" data-id="element-80" />
                        <span className="text-gray-400 text-xs md:text-sm" data-id="element-81">
                          {row.sinKit}
                        </span>
                      </div>
                    </td>
                    <td className="p-4 text-center bg-[#eab308]/10" data-id="element-82">
                      <div className="flex flex-col items-center gap-2" data-id="element-83">
                        <CheckIcon className="w-5 h-5 text-[#eab308]" strokeWidth={3} data-id="element-84" />
                        <span className="text-white font-medium text-xs md:text-sm" data-id="element-85">
                          {row.conKit}
                        </span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}